import { NavList } from "../shared";

const globalConfigAppList = [
    { url: "/global-config/embed-js", name: "Embed JS" },
    { url: "/global-config/basic-login", name: "Basic Login" },
    { url: "/global-config/abbvie-id", name: "AbbVie ID" },
    { url: "/global-config/activity-log", name: "Activity Log" },
];

const GlobalConfig = () => {
    return (
        <NavList
            backUrl="/"
            title="Global Configurations"
            navList={globalConfigAppList}
            invalidateCache
        />
    );
};

export default GlobalConfig;
